import type { ButtonTone, ButtonVariant } from './Button';

/**
 * Вид кнопки «ОК» окна-вопроса и кнопки окна сообщения, когда задан только тон: тон, который есть у `light`
 * (`success` — подтвердить, `danger` — удалить), — `light`; иначе `primary`. У `primary` тона нет: с ним тон пропал бы
 * молча, а кнопка в два нажатия с тем же тоном красная.
 */
export const confirmVariantOf = (tone: ButtonTone | undefined): ButtonVariant =>
    tone === 'success' || tone === 'danger' ? 'light' : 'primary';
